<script>
import { ref } from '@vue/composition-api'
import { ADVANCED_SETTINGS_OPTIONS } from '@/constants/advancedSettings'
import SettingsSection from '@/components/advancedSettings/SettingsSection.vue'
import GsOnlyallowedifthegroupistoolargeforasinglecontainerImage from '@/assets/helpImages/GsOnlyallowedifthegroupistoolargeforasinglecontainer.png'
import gsNeverAllowedImage from '@/assets/helpImages/GsNeverAllowed.png'
import GsAllowedImage from '@/assets/helpImages/GsAllowed.png'
import GSOnlyAllowedIfItSavesAnExtraContainerImage from '@/assets/helpImages/GSOnlyAllowedIfItSavesAnExtraContainer.png'

export default {
  components: { SettingsSection },
  props: ['value'],
  setup() {
    const groupSplittingOptions = ref(
      Object.values(ADVANCED_SETTINGS_OPTIONS.GROUP_SPLITTING_OPTIONS)
    )
    const gsNeverAllowed = gsNeverAllowedImage
    const GsOnlyallowedifthegroupistoolargeforasinglecontainer =
      GsOnlyallowedifthegroupistoolargeforasinglecontainerImage
    const GSOnlyAllowedIfItSavesAnExtraContainer =
      GSOnlyAllowedIfItSavesAnExtraContainerImage
    const GsAllowed = GsAllowedImage
    const hintBodies = [
      'Product groups may be split. Each pallet is filled to its maximum capacity. Remaining products of a product group are stacked in the next container/pallet.',
      'The starting point is that product groups should not be split, unless it saves an extra container. ',
      'The starting point is that product groups should not be split, unless a group is too large for a single container.',
      'Product groups should not be split. In case a group is too large this can lead to unloaded products.',
    ]

    const allExamples = [
      'The first pallet is filled to its maximum capacity, because the product group with ‘dotted products’ is split over 2 pallets.',
      'When the groups are not split, 3 pallets are needed for this load. However when the product group with ‘dotted products’ is split, the same load can be stacked on 2 pallets.',
      'The group with ‘striped products’ is too large for a single container. Therefore this group can be split.',
      'The group with ‘striped products’ is too large for a single container and may not be split. This will result into unloaded products.',
    ]

    const boldTexts = [
      'Allowed',
      'Only allowed if it saves an extra container',
      'Only allowed if the group is too large for a single container',
      'Never allowed',
    ]

    const images = [
      GsAllowed,
      GSOnlyAllowedIfItSavesAnExtraContainer,
      GsOnlyallowedifthegroupistoolargeforasinglecontainer,
      gsNeverAllowed,
    ]

    return {
      groupSplittingOptions,
      hintBodies,
      allExamples,
      boldTexts,
      images,
      GsAllowed,
    }
  },
}
</script>

<template>
  <settings-section
    hint-title="Group splitting"
    :hide-switch="true"
    label="Group splitting allowed"
  >
    <v-select
      :value="value"
      label="Group splitting allowed"
      :items="groupSplittingOptions"
      item-text="label"
      item-value="value"
      @input="$emit('input', $event)"
    />
    <template #content>
      <div class="content">
        <table>
          <tr v-for="(hint, index) in hintBodies" :key="index">
            <td class="left-column">
              <p>
                Group splitting = <b>{{ boldTexts[index] }}</b>
              </p>
              <p>{{ hint }}</p>
              <p>Example: {{ allExamples[index] }}</p>
            </td>
            <td class="right-column">
              <img
                :src="images[index]"
                alt="Image Description"
                class="imgSize"
              />
            </td>
          </tr>
        </table>
      </div>
    </template>
  </settings-section>
</template>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
}
td {
  border: 1px solid black;
}
.left-column {
  width: 100%;
  background-color: white;
  padding: 2rem;
}
.right-column {
  width: 100%;
  text-align: center;
  background-color: white;
}

.imgSize {
  width: 500px;
}

.content {
  padding: 16px;
}
</style>
